export type TenantRole = 'manager' | 'member';
export type TeamMemberRole = 'manager' | 'member';

/** The person's job in the sales team, read by the next-step planner (27/10/2026). */
export type SalesRole =
  | 'sdr'
  | 'account_executive'
  | 'account_manager'
  | 'customer_success'
  | 'sales_manager'
  | 'founder'
  | 'marketing'
  | 'revops'
  | 'other';

export const SALES_ROLE_LABELS: Record<SalesRole, string> = {
  sdr: 'SDR / BDR',
  account_executive: 'Account executive',
  account_manager: 'Account manager',
  customer_success: 'Customer success',
  sales_manager: 'Manager commercial',
  founder: 'Dirigeant qui vend',
  marketing: 'Marketing',
  revops: 'RevOps / Sales ops',
  other: 'Autre',
};

export const isSalesRole = (value: unknown): value is SalesRole =>
  typeof value === 'string' && Object.prototype.hasOwnProperty.call(SALES_ROLE_LABELS, value);

export interface TenantMember {
  id: string;
  tenant_id: string;
  user_id: string;
  display_name: string | null;
  tenant_role: TenantRole;
  sales_role?: SalesRole | null;
  sales_role_detail?: string | null;
  created_at: string;
  updated_at: string;
}

export interface Team {
  id: string;
  tenant_id: string;
  name: string;
  created_by: string | null;
  archived_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface TeamMember {
  id: string;
  team_id: string;
  user_id: string;
  role: TeamMemberRole;
  created_at: string;
  updated_at: string;
}
